import { BedClockIcon } from './BedClockIcon';

/**
 * author: Michael Irigoyen
 * id 91A8F1FF-F40E-44EC-A96B-776517F69769
 * name bed-clock
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bed-clock.svg
 * tags
 * - Date / Time 
 */
export const BedScheduleIcon = BedClockIcon;
export default BedScheduleIcon